<template>
  <div id="app">
    <router-view/>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/footer';
import scrollingActions from '@/util/scrollingActions';
import { useSmoothScroll } from '@/util/smoothScroll';

export default {
  name: 'app',
  components: { Footer },
  setup() {
    const isDesktop = window.innerWidth >= 768;

    let lenis, scrollTo, stop, isScrolling;
    if (isDesktop) {
      ({ lenis, scrollTo, stop, isScrolling } = useSmoothScroll());
    }

    return {
      lenis,
      scrollTo,
      stop,
      isScrolling
    };
  },
  mounted() {
    scrollingActions();
    window.onload = () => scrollingActions();
    window.onscroll = () => scrollingActions();
  },
};
</script>

<style lang="scss">
@import '@/styles/style.scss';

html {
  scroll-behavior: auto; /* Let our custom smooth scroll handle it */
}

body {
  overflow-x: hidden;
}
</style>